"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractFileUri = exports.extractErrorLoc = exports.RE_FILE_PATH_REGEX = exports.webpackErrorParser = exports.swcLoaderErrorParser = exports.lessLoaderErrorParser = exports.cssLoaderErrorParser = void 0;
var cssLoaderErrorParser_1 = require("./cssLoaderErrorParser");
Object.defineProperty(exports, "cssLoaderErrorParser", {
  enumerable: true,
  get: function () {
    return cssLoaderErrorParser_1.cssLoaderErrorParser;
  }
});
var lessLoaderErrorParser_1 = require("./lessLoaderErrorParser");
Object.defineProperty(exports, "lessLoaderErrorParser", {
  enumerable: true,
  get: function () {
    return lessLoaderErrorParser_1.lessLoaderErrorParser;
  }
});
var swcLoaderErrorParser_1 = require("./swcLoaderErrorParser");
Object.defineProperty(exports, "swcLoaderErrorParser", {
  enumerable: true,
  get: function () {
    return swcLoaderErrorParser_1.swcLoaderErrorParser;
  }
});
var webpackErrorParser_1 = require("./webpackErrorParser");
Object.defineProperty(exports, "webpackErrorParser", {
  enumerable: true,
  get: function () {
    return webpackErrorParser_1.webpackErrorParser;
  }
});
var parserUtils_1 = require("./parserUtils");
Object.defineProperty(exports, "RE_FILE_PATH_REGEX", {
  enumerable: true,
  get: function () {
    return parserUtils_1.RE_FILE_PATH_REGEX;
  }
});
Object.defineProperty(exports, "extractErrorLoc", {
  enumerable: true,
  get: function () {
    return parserUtils_1.extractErrorLoc;
  }
});
Object.defineProperty(exports, "extractFileUri", {
  enumerable: true,
  get: function () {
    return parserUtils_1.extractFileUri;
  }
});